import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddc7eb8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-testid": "profile-creation-details-experience-level-block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "experienceLevel" }

import {ref, onBeforeMount, computed} from 'vue';
    import {useStore} from 'vuex';
    import {useRouter} from 'vue-router';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import {ExperienceLevel, ProfileCreationForm} from '@/profile-creation-wizard/types';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {useGlobalProperties} from '@malt/vue3-use';

    type ExperienceLevelContent = {
        label: string;
        description: string;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CategorizationLevelSelection',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const context = useGlobalProperties();

    const creationForm = ref<ProfileCreationForm>(store.getters[getters.creationForm]);

    const experienceLevels = ref([]);
    const selectedExperienceLevel = ref(null);
    const isStrategy = ref(false);

    onBeforeMount(() => {
        experienceLevels.value = getExperienceLevels();
        selectedExperienceLevel.value = creationForm.value.experienceLevel;
        isStrategy.value = router.currentRoute.value.meta.funnelMode === ProfileCreationFunnelMode.STRATEGY;
    });

    const jobTitle = computed(() => creationForm.value.headline);

    function selectExperienceLevel(customEvent: CustomEvent): void {
        if (customEvent.detail.checked) {
            store.commit(mutations.selectExperienceLevel, customEvent.detail.value);
        } else {
            store.commit(mutations.unselectExperienceLevel);
        }
    }

    function isSelectedLevel(experienceLevel: ExperienceLevel) {
        return experienceLevel === selectedExperienceLevel.value;
    }

    function experienceLevelId(experienceLevel: ExperienceLevel): string {
        return `profile-creation-details-experience-level-${experienceLevel.toLowerCase()}`;
    }

    function getExperienceLevels(): ExperienceLevel[] {
        return Object.values(ExperienceLevel);
    }

    function getExperienceLevelContent(experienceLevel: ExperienceLevel): ExperienceLevelContent {
        return {
            label: msg(`profile.creation.completion.wizard.categorization.experienceLevel.label.v2.${experienceLevel}`),
            description: msg(`profile.creation.completion.wizard.categorization.experienceLevel.description.v2.${experienceLevel}`),
        };
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.experience.title')), 1),
    (isStrategy.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "profile-creation-details-experience-level__title",
          innerHTML: _ctx.$icu('profile.creation.wizard.strategy.categorization.experience.level.subtitle')
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "profile-creation-details-experience-level__title",
          innerHTML: _ctx.$icu('profile.creation.completion.wizard.details.job.subtitle', {jobTitle: jobTitle.value})
        }, null, 8, _hoisted_3)),
    _createVNode(_component_joy_selectable_item_group, {
      value: selectedExperienceLevel.value,
      "full-width": "",
      onJoySelectableItemGroupChange: selectExperienceLevel
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experienceLevels.value, (experienceLevel) => {
          return (_openBlock(), _createBlock(_component_joy_selectable_item, {
            key: experienceLevel,
            value: experienceLevel,
            "data-testid": experienceLevelId(experienceLevel),
            checked: isSelectedLevel(experienceLevel)
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(getExperienceLevelContent(experienceLevel).label), 1),
              _createTextVNode(" " + _toDisplayString(getExperienceLevelContent(experienceLevel).description), 1)
            ]),
            _: 2
          }, 1032, ["value", "data-testid", "checked"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})